import React from 'react';
import {
  Dialog,
  Typography,
  Stack,
  IconButton,
  Button,
  ButtonProps,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TP_COLORS } from '../../constants';

const buttonProps: ButtonProps = {
  disableElevation: true,
  variant: 'contained',
  color: 'inherit',
  sx: {
    width: '120px',
    height: '40px',
    marginTop: '50px',
    color: TP_COLORS.gray.darken,
    fontSize: '12px',
    fontWeight: '600',
    borderRadius: '6px',
    backgroundColor: TP_COLORS.border.color1,
  },
};

type TTrialClassSuccessModalProps = {
  open: boolean;
  onClose: () => void;
};

const TrialClassSuccessModal: React.FC<TTrialClassSuccessModalProps> = ({
  open,
  onClose,
}) => {
  const handleOnClick = () => {
    const url = window.location.pathname;
    window.history.replaceState(null, '', url);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { padding: '40px', borderRadius: '20px' } }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Stack alignItems="center">
        <img
          src={`${process.env.PUBLIC_URL}/images/tutorProfile/trial-class-scheduled.avif`}
          alt="trial-class-scheduled"
        />
        <Typography
          fontSize="30px"
          fontWeight="600"
          color={TP_COLORS.blue.dark}
          marginTop="30px"
        >
          Congratulations!
        </Typography>
        <Typography
          fontSize="14px"
          maxWidth="400px"
          textAlign="center"
          marginTop="20px"
          color={TP_COLORS.gray.darken}
        >
          Your trial class is successfully scheduled. Check your homepage and
          email for details.
        </Typography>
        <Button {...buttonProps} onClick={handleOnClick}>
          Dismiss
        </Button>
      </Stack>
    </Dialog>
  );
};

export default TrialClassSuccessModal;
